export default __webpack_public_path__ + "static/media/logo.ae5da470.png";